.gameBoardWrapper {
  position: relative;
  width: 600px;

  top: 50%;
  left: 50%;
  /* a bit more towards the top to make the active player's view less crowded at the bottom */
  transform: translate(-50%, -60%);

  /* centers the .gameBoardCenter*/
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  padding: 28px 56px 71px;
}

.gameBoardLeft,
.gameBoardRight,
.gameBoardTop,
.gameBoardBottom {
  position: absolute;
}

.gameBoardLeft,
.gameBoardRight {
  top: 50%;
  transform: translateY(-50%);
  height: 273px; /* TODO extract this out elsewhere */
}

.gameBoardTop,
.gameBoardBottom {
  left: 50%;
  transform: translateX(-50%);
}

.gameBoardLeft {
  right: 100%;
}
.gameBoardRight {
  left: 100%;
}

.gameBoardTop {
  bottom: 100%;
}
.gameBoardBottom {
  top: 100%;
}
.gameBoardCenter {
  position: relative;
  width: 232px;
  height: 300px;
}

.player0Portfolio {
}
